import {Component, Input, OnInit} from '@angular/core';
import {ICardDateAppointment} from '../../interfaces/card';

@Component({
  selector: 'app-card-date-appointment',
  templateUrl: './card-date-appointment.component.html',
  styleUrls: ['./card-date-appointment.component.scss']
})
export class CardDateAppointmentComponent implements OnInit {

  @Input() value: ICardDateAppointment;
  @Input() active: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
